
var testimonialColumnInter = (function () {
  return {
    init: init,
  };

  function init() {

    window.addEventListener("resize", resSlider);

    resSlider();
  }

  function resSlider() {
    var slider = new bstackSlider({
      selector: ".tc__card-testimonial",
      showDots: true,
      autoplay: false,
      rows: 1,
      slide: {
        1300: 1,
        980: 1,
        640: 1,
        320: 1
      },
      cardsInSlide: {
        1300: 3,
        980: 2,
        640: 2,
        320: 1,
      },
      emptySpaceInLastSlide: true,
    });
  }
})();

window.addEventListener("load", function () {
  testimonialColumnInter.init();
});
